import { NewTrash } from '@hungryroot/icons';
import { IconButton } from '@hungryroot/ramen';

interface TrashButtonProps {
  onClick: () => void;
  className?: string;
}

export function TrashButton(props: TrashButtonProps) {
  const { onClick, className } = props;
  return (
    <IconButton
      testid="trash-button"
      ariaLabel="Trash"
      className={className}
      size="small"
      style="default"
      prominence="secondary"
      onClick={onClick}
      icon={<NewTrash />}
    ></IconButton>
  );
}
